import { Outlet, useLocation } from "react-router";
import { useRouter } from "@/lib/router";
import { usePageMeta } from "../use-page-meta";

// 로그인 없이 볼 수 있는 약관·처리방침용 레이아웃(공개 경로).
// 이 화면은 로그인 전(랜딩·가입)과 로그인 후(설정 화면) 양쪽에서 다 들어올 수 있어서,
// "돌아가기"를 특정 주소로 고정하면 안 된다 — 예전엔 /auth/login으로 고정해뒀다가, 로그인한
// 사용자가 설정에서 들어왔다가 나가면 로그아웃 화면으로 튕기는 버그가 있었다(2026-09-30 수정).
// 브라우저 history를 그대로 되짚어 "온 곳으로" 돌아가게 하고, 이 페이지로 바로 들어온 경우
// (검색 결과·공유 링크·새 탭)처럼 되돌아갈 기록이 없으면 홈으로 보낸다.
export default function LegalLayout() {
  const router = useRouter();
  usePageMeta(useLocation().pathname);

  function goBack() {
    if (window.history.length > 1) router.back();
    else router.push("/");
  }

  return (
    <div className="mx-auto w-full max-w-2xl flex-1 px-4 py-10">
      <button
        type="button"
        onClick={goBack}
        className="text-sm text-muted-foreground hover:text-foreground"
      >
        ← 돌아가기
      </button>
      <article className="mt-6 flex flex-col gap-6 text-sm leading-relaxed [&_h1]:text-2xl [&_h1]:font-semibold [&_h2]:mt-2 [&_h2]:text-base [&_h2]:font-semibold [&_li]:ml-4 [&_li]:list-disc [&_table]:w-full [&_table]:border-collapse [&_td]:border [&_td]:border-border [&_td]:p-2 [&_th]:border [&_th]:border-border [&_th]:bg-muted [&_th]:p-2 [&_th]:text-left">
        <Outlet />
      </article>
    </div>
  );
}
